module.exports = __webpack_public_path__ + "4aabf228c187a1f498b90740687b986f.png";